var Backbone = require('backbone/backbone');
var _ = require('underscore/underscore');

var RecentNews = require('front/components/RecentNews/RecentNews');

require('./ArticleSide.less');

module.exports = Backbone.View.extend({
    el: '.ArticleSide',

    initialize: function () {
        _.bindAll(this, 'onScroll', 'initRecentNews', 'checkBannersLoaded');

        this.$recentNews = this.$('.ArticleSide-recentNews');

        this.recentNewsState = 'relative';

        this.$bannerComposite = this.$('#M390941ScriptRootC654467');

        this.checkBannersLoading = true;

        setTimeout(function () {
            this.checkBannersLoading = false;
        }.bind(this), 5000);

        new RecentNews();

        // Wait while all banners are loaded
        $(document).ready(this.checkBannersLoaded);
    },

    checkBannersLoaded: function () {
        if (!this.checkBannersLoading || this.$bannerComposite.height() != 0) this.initRecentNews();
        else setTimeout(this.checkBannersLoaded, 100);
    },

    initRecentNews: function () {
        var recentNewsHeight = this.$recentNews.outerHeight();
        var bottom = this.$el.offset().top + this.$el.outerHeight();
        var contentBottom = this.$bannerComposite.offset().top + this.$bannerComposite.outerHeight();

        // If recent news block doesn't fit in the side block, don't show it
        if (contentBottom + recentNewsHeight > bottom) return;
        else this.$recentNews.addClass('ArticleSide-recentNews--isVisible');

        this.onScroll.__throttled = _.throttle(this.onScroll, 20);
        $(window).on('scroll', this.onScroll.__throttled);
    },

    onScroll: function () {
        var newsOffsetTop = this.$recentNews.offset().top;
        var newsBottom = this.$recentNews.position().top + this.$recentNews.outerHeight();
        var bottom = this.$el.offset().top + this.$el.height();

        if (this.recentNewsState == 'relative') {
            // If scroll to recent news fixed them
            if (newsOffsetTop <= $(window).scrollTop() + 150) {
                this.$recentNews.addClass('ArticleSide-recentNews--isFixed');
                this.recentNewsState = 'fixed';
                this.newsOffsetTop = newsOffsetTop;
            }

            return;
        }

        if (this.recentNewsState == 'fixed') {
            if (newsOffsetTop < this.newsOffsetTop) {
                this.$recentNews.removeClass('ArticleSide-recentNews--isFixed');
                this.recentNewsState = 'relative';
            }

            // If news block on 20px distance from article side bottom
            if (newsBottom >= bottom - $(window).scrollTop() - 20) {
                this.$recentNews.removeClass('ArticleSide-recentNews--isFixed').addClass('ArticleSide-recentNews--isAbsolute');
                this.recentNewsState = 'absolute';
                this.newsScrollTop = $(window).scrollTop();
            }

            return;
        }

        if (this.recentNewsState == 'absolute') {
            if ($(window).scrollTop() < this.newsScrollTop) {
                this.$recentNews.removeClass('ArticleSide-recentNews--isAbsolute').addClass('ArticleSide-recentNews--isFixed');
                this.recentNewsState = 'fixed';
            }
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/ArticleSide/ArticleSide.js
// module id = 166
// module chunks = 0